import {Component, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {Observationcancel} from '../../../model/Observationcancel';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import {Document} from '../../../model/Document';
import {Constant} from '../../../../global/util/Constant';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-document',
  templateUrl: './cancel-document.component.html',
  styleUrls: ['./cancel-document.component.css']
})
export class CancelDocumentComponent implements OnInit {

  public document: Document;
  public loading: boolean;
  public title = 'TITLE.CANCEL-DOCUMENT';
  public body = 'QUESTION.ARE-YOU-SURE-CANCEL-DOCUMENT';
  public observationcancel = new Observationcancel();

  constructor(private activeModal: NgbActiveModal,
              private documentService: DocumentService,
              private modalService: NgbModal,
              private router: Router,
              private applicationService: ApplicationService,
              private authenticationService: AuthService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit(): void {
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
  }

  public yes(): void {
    this.setValuesBefore2Save();
    const url = Constant.ROOT_API_V1
      .concat('/documents/')
      .concat(String(this.document.id))
      .concat('/cancel');
    const formData = new FormData();
    formData.append('comment', this.observationcancel.description);
    this.loading = true;
    this.documentService.cancel(url, formData).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.processError(error);
    });
  }

  public no(): void {
    this.activeModal.close();
  }

  private setValuesBefore2Save(): void {
    this.observationcancel.documentId = this.document.id;
  }

  private processError(error: any): void {
    this.title = this.translate.instant('TITLE.CANCEL-DOCUMENT');
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    } else {
      Dialog.show(InformType.Danger, this.title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }
}
